import cx from "clsx";
import { SocialLink } from "kreate-common/modules/business-types";
import Flex from "kreate-common/modules/kreate-ui/components/Flex";
import Link from "next/link";
import React from "react";
import { MdLanguage } from "react-icons/md";

import styles from "./index.module.scss";

import { CHANNEL_KEY_TO_CHANNEL_INFO } from "@/modules/social-links/config";
import { extractUrl } from "@/modules/social-links/utils";

type Size = `${number}${"px" | "em"}`;

type Props = {
  className?: string;
  style?: React.CSSProperties;
  socialLinks: SocialLink[] | null | undefined;
  justifyContent?: React.CSSProperties["justifyContent"];
  iconSize?: Size;
  gap?: Size;
};

export default function SocialLinksViewer({
  className,
  style,
  socialLinks,
  justifyContent = "flex-start",
  iconSize = "32px",
  gap = "0.375em",
}: Props) {
  return (
    <div
      className={cx(styles.container, className)}
      style={{ ...style, fontSize: iconSize }}
    >
      <Flex.Row
        alignItems="center"
        gap={gap}
        flexWrap="wrap"
        justifyContent={justifyContent}
      >
        {socialLinks?.map((href, index) => {
          const { host } = extractUrl(href);
          const channelInfo = Object.values(CHANNEL_KEY_TO_CHANNEL_INFO).find(
            (channelInfo) =>
              channelInfo.acceptedDomains.some(
                (d) => d === host || host.endsWith("." + d)
              )
          );
          return (
            <Link
              key={index}
              href={href}
              className={styles.iconContainer}
              style={{
                width: "1em",
                height: "1em",
              }}
              rel="noreferer"
              target="_blank"
            >
              <Flex.Row
                style={{ fontSize: "0.5em" }}
                justifyContent="center"
                alignItems="center"
              >
                {channelInfo?.icon || <MdLanguage />}
              </Flex.Row>
            </Link>
          );
        })}
      </Flex.Row>
    </div>
  );
}
